// @flow
import { connect } from 'react-redux'
import type { AppStateType } from '../../../reducers/appstate'
import type { Dispatch } from 'redux'
import SharedCta from './SharedCta'
import type { DispatchPropsType } from './SharedCta'
import {
  togglePromoModal,
  setHeaderCopyForAuthAndSubscribeModals
} from '../../../actions/promoActions'
import type {
  PaywallCtaType,
  CtaDataType
} from '../../../services/contentfulMarketingLandingPages'

type OwnPropsType = {
  cta: CtaDataType,
  isSmall?: boolean
}

const mapStateToProps = (state: AppStateType, ownProps: OwnPropsType): any => {
  return {
    cta: ownProps.cta,
    isSmall: !!ownProps.isSmall
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>): any => {
  return ({
    toggleModal: (): void => dispatch(togglePromoModal()),
    setHeaderCopy: (paywallCta: PaywallCtaType): void => {
      dispatch(
        setHeaderCopyForAuthAndSubscribeModals(
          null,
          paywallCta.authSubheaderText ||
            'Explore hundreds of sexy audio stories stories, bingeable books, wellness sessions, and sleep scenes.',
          paywallCta.confirmationHeaderText,
          paywallCta.confirmationSubheaderText
        )
      )
    }
  }: DispatchPropsType)
}

export default connect<DispatchPropsType, {}, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(SharedCta)
